/**
 * Copyright 2026 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";
import SummitAddonSelect from "../summit-addon-select";

const MuiFormikSummitAddonSelect = ({
  name,
  summitId,
  placeholder = "Select...",
  inputProps = {}
}) => {
  const [field, meta, helpers] = useField(name);

  return (
    <SummitAddonSelect
      value={field.value || ""}
      summitId={summitId}
      onChange={helpers.setValue}
      placeholder={placeholder}
      inputProps={{
        error: meta.touched && Boolean(meta.error),
        helperText: meta.touched && meta.error,
        ...inputProps
      }}
    />
  );
};

MuiFormikSummitAddonSelect.propTypes = {
  name: PropTypes.string.isRequired,
  summitId: PropTypes.number.isRequired,
  placeholder: PropTypes.string,
  inputProps: PropTypes.object
};

export default MuiFormikSummitAddonSelect;
